<template>
  <!-- Mobile: maxWidth 100vw prevents the drawer from overflowing on screens narrower than 375px -->
  <Drawer
    v-bind="$attrs"
    :style="{ width: '375px', maxWidth: '100vw' }"
    :position="position"
    :persistent="true"
    :dismissable="dismissable"
    :close-button-props="{
      class: 'h-[36px]! w-[36px]! border-0!',
      severity: 'secondary',
    }"
    close-icon="pi pi-times text-[14px]!"
    :close-on-escape="false"
  >
    <slot></slot>
  </Drawer>
</template>

<script lang="ts" setup>
import Drawer from 'primevue/drawer';

const { position = 'right', dismissable = false } = defineProps<{
  position?: 'left' | 'right' | 'top' | 'bottom' | 'full';
  dismissable?: boolean;
}>();

defineOptions({
  inheritAttrs: false, // important to avoid double binding
});
</script>
